import React,{useContext, useEffect, useState} from 'react';
import AuthContext from '../../context/auth/authContext';
import AlertContext from '../../context/alert/alertContext';
import { useNavigate } from 'react-router-dom';
import Alerts from '../layout/Alerts';

import { Container, Button, Form,Row, Col} from "react-bootstrap";
import logo from '../../img/logo.svg';
import logoWhite from '../../img/logo-white.svg';
import loginBg from '../../img/login-bg.jpg';

const Register = () => {

    const alertContext = useContext(AlertContext);

    const {setAlert} = alertContext;
    const authContext = useContext(AuthContext);
    const{login, register, error, isAuthenticated, clearErrors} = authContext;

    const navigate = useNavigate();

    useEffect(() => {

        if(isAuthenticated){
            navigate('/');
        }
        if(error === 'User not found'){
            //do something
            setAlert(error, 'danger');
            clearErrors();
            //console.log('Invalid Credentials error handler');
            
        }
        // eslint-disable-next-line
    },[error,isAuthenticated])

    const [user, setUser] = useState({

        email: '',
        password: '',
        password2: ''

    });

    const {email, password, password2} = user;

    const onChange = e => setUser({...user, [e.target.name]: e.target.value});

    const onSubmit = e =>{
        e.preventDefault();
        if(email === '' || password=== ''){
            setAlert('Please fill in all fields','danger');
        }
        else if(password !== password2){
            setAlert('Passwords do not match','danger');
        }
        else{
            register({email,password});
        }
    }



    return (
    <>
        <div className='d-none d-md-block login-background'></div>
        <Container>

            <h1 className='h1 mt-5 font-size-0'>
                <img src={logo} className='logo' /> Bladonmore portal
            </h1>
        </Container>
        <Container>
            <Row>
                <Col md="5" className='d-flex flex-column justify-content-center h-100 form-container pe-5'>
                    <div className='alerts'>
                        <Alerts />
                    </div>
                    <h2 className='mb-4 login-h2'>Register</h2>
                    <p>
                        Please use the following form to enter your email and set a password
                    </p>

                    <Form onSubmit={onSubmit}>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">                                
                                    <Form.Label  htmlFor='email' hidden>Email Address</Form.Label>
                                    <Form.Control type='text' name='email' values={email} onChange={onChange} className="login-input" placeholder='Email or Username'/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label htmlFor='password' hidden>Password</Form.Label> 
                                    <Form.Control type='password' name='password' values={password} onChange={onChange} className="login-input" placeholder='Password' minlength='8'/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label htmlFor='password2' hidden>Comfirm Password</Form.Label> 
                                    <Form.Control type='password' name='password2' values={password2} onChange={onChange} className="login-input" placeholder='Confirm Password' minlength='8'/>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group >
                            <Button variant="primary" type="submit" className="w-100 btn btn-yellow login-button">Register</Button>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </Container>
    </>
    )
}

export default Register